<fm-balloon-header [color]="balloon?.categoryColor" [title]="balloon?.name" [subtitle]="balloon?.address"></fm-balloon-header>
<fm-balloon-section>
  <div class="place-balloon-category">
    <div class="place-balloon-category__label"><span i18n="@@S_CATEGORY">Category</span>:</div>
    <span>{{ balloon?.category }}</span>
  </div>
</fm-balloon-section>
<fm-balloon-actions>
  <button
    mat-button
    class="vzc-small"
    *ngIf="permissions?.liveMapFindNearest !== EPermissionStatus.Disabled"
    id="btn-balloon-find-nearest"
    [attr.a7s-id]="
      balloon?.type === EPlotType.hotspot
        ? 'live-map-map-suggested-geofence-info-card-find-nearest'
        : 'live-map-map-geofence-info-card-find-nearest'
    "
    i18n="@@S_FIND_NEAREST"
    (click)="onFindNearest()"
  >
    Find Nearest
  </button>
  <button
    mat-button
    class="vzc-small"
    *ngIf="permissions?.managePlaces === EPermissionStatus.Full"
    id="btn-balloon-edit"
    [attr.a7s-id]="
      balloon?.type === EPlotType.hotspot ? 'live-map-map-suggested-geofence-info-card-edit' : 'live-map-map-geofence-info-card-edit'
    "
    i18n="@@S_EDIT"
    (click)="onEdit()"
  >
    Edit
  </button>
  <button
    mat-button
    class="vzc-small"
    *ngIf="permissions?.places === EPermissionStatus.Full"
    id="btn-balloon-view-metrics"
    [attr.a7s-id]="
      balloon?.type === EPlotType.hotspot
        ? 'live-map-map-suggested-geofence-info-card-view-metrics'
        : 'live-map-map-geofence-info-card-view-metrics'
    "
    i18n="@@S_VIEWMETRICS"
    (click)="onViewMetrics()"
  >
    View Metrics
  </button>
</fm-balloon-actions>
